var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h1", { staticClass: "subtitle is-5" }, [_vm._v("Serie Documental")]),
    _vm._v(" "),
    _c("h1", { staticClass: "title is-5" }, [
      _vm._v(_vm._s(_vm.unidadCompuesta.serie_documental.nombre)),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("p", { staticClass: "is-size-7" }, [
        _vm._v(_vm._s(_vm.unidadCompuesta.serie_documental.descripcion)),
      ]),
    ]),
    _vm._v(" "),
    _c("h6", { staticClass: "title is-6 mb-2" }, [_vm._v("Estados")]),
    _vm._v(" "),
    _c("p", { staticClass: "is-size-7 my-2" }, [_vm._v("(*) Estado inicial")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "tags my-2" },
      _vm._l(
        _vm.unidadCompuesta.serie_documental.estados,
        function (estado, index) {
          return _c(
            "span",
            {
              key: index,
              staticClass: "tag",
              class:
                _vm.unidadCompuesta.serie_documental.estado_inicial === index
                  ? "is-primary"
                  : "is-primary is-light",
            },
            [
              _vm._v(_vm._s(estado) + " "),
              _vm.unidadCompuesta.serie_documental.estado_inicial === index
                ? _c("span", [_vm._v(" *")])
                : _vm._e(),
            ]
          )
        }
      ),
      0
    ),
    _vm._v(" "),
    _c("h6", { staticClass: "title is-6 mb-3" }, [_vm._v("Subunidades")]),
    _vm._v(" "),
    !_vm.isObjectEmpty(_vm.unidadCompuesta.serie_documental.estructura)
      ? _c(
          "div",
          { staticClass: "columns is-multiline" },
          _vm._l(
            _vm.unidadCompuesta.serie_documental.estructura,
            function (subunidad, index) {
              return _c("div", { key: index, staticClass: "column is-6" }, [
                _c("p", { staticClass: "has-text-primary" }, [
                  _c("i", {
                    staticClass: "fas",
                    class: subunidad.multiple ? "fa-copy" : "fa-file",
                  }),
                  _vm._v("\n         " + _vm._s(subunidad.nombre) + "\n      "),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "is-size-7" }, [
                  _vm._v("Formatos: " + _vm._s(subunidad.formatos.join(", "))),
                ]),
              ])
            }
          ),
          0
        )
      : _c("div", { staticClass: "content" }, [
          _c("p", { staticClass: "is-size-7" }, [
            _vm._v("No hay subunidades asociados a la serie documental"),
          ]),
        ]),
    _vm._v(" "),
    _c("h6", { staticClass: "title is-6" }, [_vm._v("Aspectos")]),
    _vm._v(" "),
    _vm.unidadCompuesta.aspectos.length
      ? _c(
          "div",
          { staticClass: "columns is-multiline" },
          _vm._l(_vm.unidadCompuesta.aspectos, function (aspecto, index) {
            return _c("div", { key: index, staticClass: "column is-6" }, [
              _c("p", { staticClass: "has-text-primary" }, [
                _c("i", { staticClass: "fas fa-caret-right" }),
                _vm._v("\n         " + _vm._s(aspecto.nombre) + "\n      "),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "is-size-7" }, [
                _vm._v(_vm._s(aspecto.descripcion)),
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("p", { staticClass: "is-size-7" }, [
                _vm._v(
                  "Atributos: " +
                    _vm._s(aspecto.atributos.map((x) => x.nombre).join(", "))
                ),
              ]),
            ])
          }),
          0
        )
      : _c("div", { staticClass: "content" }, [
          _c("p", { staticClass: "is-size-7" }, [
            _vm._v("No hay aspectos asociados a la serie documental"),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }